import { render, staticRenderFns } from "./AjudaView.vue?vue&type=template&id=f0254154&scoped=true&"
import script from "./AjudaView.vue?vue&type=script&lang=js&"
export * from "./AjudaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0254154",
  null
  
)

export default component.exports